<template>
	<!-- Drawer backdrop (HAP-1888): dims + blurs the page behind the open drawer,
	     tap anywhere to close. Fades with the P0.2 motion tokens; sits just under
	     the drawer (z-[59]) and above the nav bars (z-50). -->
	<div
		class="fixed inset-0 z-[59] bg-black/40 backdrop-blur-[2px] transition-opacity duration-300 ease-standard print:hidden"
		:class="store.hamburgerMenu ? 'opacity-100' : 'opacity-0 pointer-events-none'"
		@click="store.hamburgerMenu = false"
	/>

	<!-- Hamburger Menu -->
	<div
		class="select-none print:hidden w-full sm:max-w-sm transition-transform transform-gpu duration-500 ease-standard bg-white border-l-4 border-gray-200 shadow-lg h-screen fixed right-0 z-[60] pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] dark:bg-gray-800 dark:border-gray-600 dark:text-ncfic-blue-100"
		:class="store.hamburgerMenu ? '' : 'translate-x-full'"
		:style="drag.dragging ? { transform: `translateX(${Math.max(0, drag.dx)}px)`, transition: 'none' } : null"
		@click.stop
		@pointerdown="onDragStart"
		@pointermove="onDragMove"
		@pointerup="onDragEnd"
		@pointercancel="onDragEnd"
		style="touch-action: pan-y"
	>
		<!-- dark:bg-ncfic-blue-900 dark:border-ncfic-blue-400 dark:text-ncfic-blue-100" -->

		<button class="absolute top-[env(safe-area-inset-top)] right-0 cursor-pointer m-4" aria-label="Close menu" @click="store.hamburgerMenu = false">
			<i class="fal fa-lg fa-times" aria-hidden="true" />
		</button>

		<div class="flex flex-col text-xl space-y-6 p-8 border-b dark:border-gray-600" @click="store.hamburgerMenu = false">
			<router-link class="border-b border-transparent hover:underline" to="/account"> Account </router-link>
			<component :is="link.path ? 'router-link' : 'div'" v-for="link in links" class="border-b border-transparent inline-block" :class="link.path ? 'hover:underline' : ''" :key="link.name" :to="link.path" @click="!link.path ? $event.stopPropagation() : null">
				{{ link.name }}
				<div v-if="link.subnav" class="">
					<div class="ml-8 flex flex-col space-y-4 mt-4">
						<router-link v-for="sublink in link.subnav" :key="sublink.name" class="hover:text-blue-400 text-sm" :to="sublink.path" @click="store.hamburgerMenu = false">
							{{ sublink.name }}
						</router-link>
					</div>
				</div>
			</component>
			<div class="space-y-4 pt-6">
				<div class="text-sm">
					<router-link to="/" class="hover:underline"> Church &amp; Family Life&nbsp;&nbsp;&nbsp;<i class="fal fa-sm fa-long-arrow-right inline" /> </router-link>
				</div>
				<div class="text-sm">
					<router-link to="/network/" class="hover:underline"> FIC Network&nbsp;&nbsp;&nbsp;<i class="fal fa-sm fa-long-arrow-right inline" /> </router-link>
				</div>
				<div class="text-sm">
					<router-link :to="`/sermons?filters={%22speakers%22:[{%22title%22:%22Scott+Brown%22,%22image%22:{%22width%22:100,%22height%22:100,%22url%22:%22https://cfl-mango.s3.amazonaws.com/assets/people/60ca3431e7346d3c2b733f3d/image.jpg%22},%22id%22:%2260ca3431e7346d3c2b733f3d%22,%22objectID%22:%2260ca3431e7346d3c2b733f3d%22,%22_highlightResult%22:{%22title%22:{%22value%22:%22%3Cem%3ESc%3C/em%3Eott+Brown%22,%22matchLevel%22:%22full%22,%22fullyHighlighted%22:false,%22matchedWords%22:[%22sc%22]}}}],%22church%22:[],%22series%22:[],%22book%22:[],%22duration%22:[0,4500]}`" class="hover:underline"> Expository Preaching&nbsp;&nbsp;&nbsp;<i class="fal fa-sm fa-long-arrow-right inline" /> </router-link>
				</div>
			</div>
		</div>
		<div @click.stop class="p-8 border-b dark:border-gray-600 text-sm">
			<div>
				<div class="flex flex-wrap">
					<div class="text-lg mb-4">Subscribe to our Mailing List</div>
					<input class="border-b py-2 placeholder:text-gray-400 w-full bg-transparent outline-ncfic-blue-300 focus:px-3 dark-sidebar" placeholder="Email Address" v-model="email" @keyup.enter="$refs.navSub.subscribe" />
					<Subscribe source="home_page" list="master" :email="email" ref="navSub" class="bg-gray-200 px-3 mt-6 py-2 text-black rounded outline-ncfic-blue-300"> Subscribe </Subscribe>
				</div>
			</div>
		</div>
		<div @click.stop class="p-8 text-sm">
			<div>The mission of Church &amp; Family Life is to proclaim the sufficiency of Scripture for both church and family life.</div>
		</div>
	</div>

	<div class="hidden md:block">
		<router-link to="/products" v-if="new Date() < new Date('12/17/2022') && new Date() > new Date('12/9/2022')" class="space-x-8 sticky top-0 backdrop-blur text-center text-white hover:font-bold bg-gradient-to-r from-blue-500/70 to-red-500/70 via-orange-800/70 transition-all duration-1500 border-b border-ncfic-blue-100 flex justify-center items-center px-4 top-0 w-full h-14 z-50 dark:border-gray-600"> <strong>Holiday Sale</strong>: 40% off all products! </router-link>

		<!-- Top Nav Bar -->
		<div class="sticky top-0 z-50 mainnav transition-all duration-300 overflow-hidden" :class="[false && nationalConference ? 'dark -mt-14' : '', hidden ? 'max-h-0 opacity-0' : 'max-h-14 opacity-100']">
			<div class="backdrop-blur text-ncfic-blue-500 border-b border-ncfic-blue-100 bg-white/90 w-full h-14 dark:text-ncfic-blue-100 dark:border-gray-600 dark:bg-gray-800/50 print:hidden">
				<!-- dark:text-ncfic-blue-100 dark:border-ncfic-blue-400 dark:bg-ncfic-blue-900 dark:border-b-4 -->
				<div class="w-full flex justify-between items-center px-4 sm:px-6 h-full space-x-8">
				<router-link class="flex items-center space-x-3 shrink-0" to="/">
					<logo alt="Church &amp; Family Life" class="fill-ncfic-blue-700 dark:fill-ncfic-blue-50 w-12 shrink-0" />
					<span class="cfl-wordmark block bg-ncfic-blue-700 dark:bg-ncfic-blue-50 h-[18px] w-[150px] shrink-0" role="img" aria-label="Church &amp; Family Life" />
				</router-link>
				<div class="hidden xl:flex items-center space-x-8 whitespace-nowrap">
					<template v-for="link in links" :key="link.name">
						<!-- v-if="index <= 4 || breakpoints.lg" -->
						<component :is="link.path ? 'router-link' : 'div'" class="py-1 group relative inline-block" :to="link.path">
							<span class="group-hover:text-blue-400">{{ link.name }}</span>
							<div v-if="link.subnav" class="hidden group-hover:block">
								<div class="absolute top-full inset-x-0 bg-white dark:bg-black shadow-card dark:shadow-sky-500/30 border border-t-0 border-gray-200 dark:border-sky-500/50 rounded-lg p-4 space-y-2 flex flex-col w-[200px]">
									<router-link v-for="sublink in link.subnav" :key="sublink.name" class="hover:text-blue-400" :to="sublink.path">
										{{ sublink.name }}
									</router-link>
								</div>
							</div>
						</component>
					</template>
				</div>
				<div class="flex justify-end items-center space-x-4 shrink-0">
					<!-- <Menu as="div" class="relative inline-block text-left">
                        <MenuButton><i class="fad fa-language text-2xl" /></MenuButton>
                        <MenuItems class="absolute right-0 mt-2 w-28 origin-top-right divide-y dark:divide-gray-700 dark:border dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 flex flex-col shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                            <MenuItem v-slot="{ active }" class="p-2">
                                <a :class='{ "bg-gray-100 dark:bg-gray-600": active }' href="https://churchandfamilylife.com">
                                English
                                </a>
                            </MenuItem>
                            <MenuItem v-slot="{ active }" class="p-2">
                                <a :class='{ "bg-gray-100 dark:bg-gray-600": active }' href="https://es.ncfic.org">
                                Español
                                </a>
                            </MenuItem>
                            <MenuItem v-slot="{ active }" class="p-2">
                                <a :class='{ "bg-gray-100 dark:bg-gray-600": active }' href="https://churchandfamilylife.com/cn">
                                简体中文
                                </a>
                            </MenuItem>
                        </MenuItems>
                    </Menu> -->
					<button v-if="store.user?.member?.roles?.includes('admin') && $route.params?.id" @click="openAdminPage" class="text-lg" aria-label="Edit in admin"><i class="fad fa-pencil-alt" aria-hidden="true" /></button>
					<button @click="darkMode.toggle" class="text-xl" aria-label="Toggle dark mode"><i aria-hidden="true" class="fad" :class="!darkMode.enabled ? 'fa-sun' : 'fa-moon-stars mb-2'" /></button>
					<button @click="showSearch = true" aria-label="Search"><i aria-hidden="true" class="fal fa-search text-ncfic-blue-700 dark:text-ncfic-blue-50" /></button>
					<router-link to="/cart" v-if="store.cartTotalItems" class="relative text-center" :aria-label="`Cart (${store.cartTotalItems} items)`">
						<i aria-hidden="true" class="fal fa-shopping-cart text-ncfic-blue-700 dark:text-ncfic-blue-50" />
						<div class="w-4 h-4 bg-ncfic-red-500 text-white text-2xs rounded-full absolute -top-1 -left-1 flex items-center justify-center" v-html="store.cartTotalItems" />
					</router-link>
					<button class="" aria-label="Account" @click="store.user?.member?.id ? $router.push('/account') : (showLogin = true)"><i aria-hidden="true" :class="store.user?.member?.id ? 'fas' : 'fal'" class="fa-user-circle text-ncfic-blue-700 dark:text-ncfic-blue-50" /></button>
					<button class="xl:hidden" aria-label="Menu" :aria-expanded="store.hamburgerMenu ? 'true' : 'false'" @click.stop="store.hamburgerMenu = !store.hamburgerMenu"><i aria-hidden="true" class="fal fa-bars text-ncfic-blue-700 dark:text-ncfic-blue-50 text-lg" /></button>
				</div>
				</div>
			</div>

			<!-- Toast -->

			<!-- <router-link to="/donate" class="flex items-center justify-center text-sm md:text-base w-full bg-gradient-to-tr md:bg-gradient-to-r from-ncfic-blue-300 to-ncfic-green-300 via-gray-100 dark:from-ncfic-blue-800 dark:to-ncfic-green-800 dark:via-gray-800 px-4 py-2 text-center font-semibold uppercase border-b-2 dark:border-gray-700">
                Donate now and double the impact with a matching gift of $100k!
            </router-link> -->

			<!-- <router-link to="/donate" class="bg-contain bg-no-repeat bg-left py-4 border-b flex justify-end" style="background-image: url(https://cfl-mango.s3.amazonaws.com/uploads/events/2023-donation-matching/background.png)" >
                <img src="https://cfl-mango.s3.amazonaws.com/uploads/events/2023-donation-matching/text.png" class="w-full max-w-sm mx-auto" />
            </router-link> -->
		</div>
		<!-- <div class="w-full h-14" v-show="!hidden" /> -->

		<CommandPalette v-if="showSearch" @hide="showSearch = false" />
	</div>

	<Login @hide="hideLogin" @loggedIn="loggedInCallback" v-if="showLogin || store?.login?.next" :allowGuest="true" />
</template>

<script>
import logo from '../../assets/logo.vue'
import Login from '../layout/login.vue'
import Subscribe from './subscribe.vue'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import CommandPalette from './command-palette.vue'
import { useHaptics } from '../../composables/useHaptics'

const haptics = useHaptics()

// Swipe-to-close threshold: drag the drawer right past this many px to dismiss.
const DRAWER_DISMISS_DISTANCE = 80

export default {
	components: { logo, Login, Subscribe, Menu, MenuButton, MenuItems, MenuItem, CommandPalette },
	props: { hidden: { type: Boolean, default: false } },
	inject: ['store', 'darkMode'],
	data() {
		return {
			showLogin: false,
			showSearch: false,
			keyListener: null,
			// Swipe-to-close drag state for the hamburger drawer (HAP-1888).
			drag: { tracking: false, dragging: false, decided: false, startX: 0, startY: 0, dx: 0 },
			email: null,
			links: [
				{ name: `About`, path: `/about` },
				{ name: `Network`, path: `/network/index` },
				{ name: `Events`, path: `/events` },
				// { name: `Podcast`, subnav: [
				//     { name: `Church & Family Life`, path: `/podcasts`},
				//     {name: `Living Biblically`, path: `/living-biblically`},
				//     {name: `Scripture Applied`, path: `/scripture-applied`}
				// ] },
				{ name: `Podcasts`, path: `/podcasts` },
				{ name: `Resources`, path: `/resources` },
				{ name: `Store`, path: `/products` },
				{ name: `Donate`, path: `/donate` },
			],
		}
	},
	mounted() {
		this.keyListener = function (e) {
			if (e.key === 'k' && (e.ctrlKey || e.metaKey)) {
				e.preventDefault() // present "Save Page" from getting triggered.
				this.showSearch = !this.showSearch
			}
		}
		// Store the BOUND function: binding inline handed removeEventListener a
		// different reference, so the listener was never removed.
		this.keyListener = this.keyListener.bind(this)
		document.addEventListener('keydown', this.keyListener)
	},
	beforeUnmount() {
		document.removeEventListener('keydown', this.keyListener)
	},
	watch: {
		// The search palette never survives a navigation, whoever triggered it (HAP-4825).
		$route() {
			this.showSearch = false
		},
		loggedIn() {
			if (this.loggedIn) {
				console.log('typeof this.store.login?.next == `function`', typeof this.store.login?.next == 'function')
				if (typeof this.store.login?.next == 'function') this.store.login.next()
				else if (this.store.login?.next) this.$router.push(this.store.login.next)
			}
		},
	},
	methods: {
		// --- Drawer swipe-to-close (HAP-1888) ------------------------------------
		// Touch-action:pan-y on the drawer keeps vertical scroll native and hands us
		// horizontal drags. We only start dragging once horizontal intent is clear,
		// follow the finger (rightward only), and dismiss past the threshold; the
		// inline transform/transition is released on end so the CSS spring takes
		// over to snap closed or back open.
		onDragStart(e) {
			if (!this.store.hamburgerMenu) return
			this.drag.tracking = true
			this.drag.decided = false
			this.drag.dragging = false
			this.drag.startX = e.clientX
			this.drag.startY = e.clientY
			this.drag.dx = 0
		},
		onDragMove(e) {
			if (!this.drag.tracking) return
			const dx = e.clientX - this.drag.startX
			const dy = e.clientY - this.drag.startY
			if (!this.drag.decided) {
				// Wait until the gesture clears a small deadzone, then lock its axis.
				if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return
				this.drag.decided = true
				// Vertical intent → let the drawer scroll; bail out of the drag.
				if (Math.abs(dy) > Math.abs(dx)) {
					this.drag.tracking = false
					return
				}
				this.drag.dragging = true
			}
			if (this.drag.dragging) this.drag.dx = Math.max(0, dx)
		},
		onDragEnd() {
			if (!this.drag.tracking) return
			const shouldClose = this.drag.dragging && this.drag.dx > DRAWER_DISMISS_DISTANCE
			this.drag.tracking = false
			this.drag.dragging = false
			this.drag.decided = false
			this.drag.dx = 0
			if (shouldClose) {
				haptics.light()
				this.store.hamburgerMenu = false
			}
		},
		hideLogin() {
			this.$nextTick(() => {
				this.showLogin = false
				if (this.store.login?.next) this.store.login.next = null
			})
		},
		loggedInCallback() {
			console.log('typeof this.store.login?.next == `function`', typeof this.store.login?.next == 'function')
			if (typeof this.store.login?.next == 'function') this.store.login.next()
			else if (this.store.login?.next) this.$router.push(this.store.login.next)
		},
		openAdminPage() {
			let collection = this.$route.path.split('/')[1]
			collection = ['network', 'church-network'].includes(collection) ? 'churches' : collection
			collection = ['about'].includes(collection) ? 'aboutPages' : collection
			collection = ['podcasts'].includes(collection) ? 'podcastEpisodes' : collection
			let id = this.$route.params?.id

			let path = `https://admin.churchandfamilylife.com/${collection}/${id}`
			// window.open(path, "_blank") || window.location.replace(path);
			window.location.replace(path)
		},
	},
	computed: {
		loggedIn() {
			return this.store.user?.member?.id
		},
		nationalConference() {
			return this.$route.params?.id == '65f06e8db04a89346884a83b'
		},
	},
}
</script>

<style lang="postcss" scoped>
input,
label {
	@apply border border-gray-300 rounded outline-blue-400 dark:outline-blue-500/40 focus-visible:dark:outline-blue-500/40 px-3 py-2 dark:bg-transparent dark:border-gray-600 dark:placeholder-gray-600;
}
input.dark-sidebar {
	@apply dark:border-white/70 dark:placeholder:text-white/30 dark:text-white;
}
.cfl-wordmark {
	-webkit-mask: url('/cfl-text-logo.png') no-repeat center / contain;
	mask: url('/cfl-text-logo.png') no-repeat center / contain;
}
</style>
